import BaseListStyle from "../../styles/BaseListStyle"; 

const FuelAnnexViewStyles = (theme) => { 
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    backGroundGrey: {
      background:"#A6A6A6",
    },
    backGroundYellow: {
      background:"yellow",
    },
    backgroundGreen: {
      background:"#33B71A",
    },
    tableStyle: {
      color: "black",
      fontSize: "11pt",
      textAlign: "center",
      verticalAlign: "middle",
    },
    headersMain: {
      fontSize:"12.0pt",
      fontWeight:700,
      fontFamily: "Arial, cursive",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
    },
    headersSub: {
      fontSize:"9.0pt",
      fontWeight:700,
      fontFamily: "Arial, cursive",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
    },
    thinBorder: {
      borderTop: "0.5pt solid #000000",
      borderRight: "0.5pt solid #000000",
      borderBottom: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
    },
    thinLeftTopBorder: {
      borderTop: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
    },
    thinLeftBottomBorder: {
      borderLeft: "0.5pt solid #000000",
      borderBottom: "0.5pt solid #000000",
    },
    thinNoBottomBorder: {
      borderTop: "0.5pt solid #000000",
      borderRight: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
    },
    thinNoTopBorder: {
      borderRight: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
      borderBottom: "0.5pt solid #000000",
    },
    thinLeftBorder: {
      borderLeft: "0.5pt solid #000000",
    },
    thinRightBorder: {
      borderRight: "0.5pt solid #000000",
    },

    topLeftBorder: {
      borderTop: "1.0pt solid #000000",
      borderLeft: "1.0pt solid #000000",
    },
    topBorder: {
      borderTop: "1.0pt solid #000000",
    },
    topRightBorder: {
      borderTop: "1.0pt solid #000000",
      borderRight: "1.0pt solid #000000",
    },
    leftBorder: {
      borderLeft: "1.0pt solid #000000",
    },
    rightBorder: {
      borderRight: "1.0pt solid #000000",
    },
    bottomLeftBorder: {
      borderBottom: "1.0pt solid #000000",
      borderLeft: "1.0pt solid #000000",
    },
    bottomBorder: {
      borderBottom: "1.0pt solid #000000",
    },
    bottomRightBorder: {
      borderRight: "1.0pt solid #000000",
      borderBottom: "1.0pt solid #000000",
    },
    noTopBorder: {
      borderTop: "none",
    },
    noLeftBorder: {
      borderLeft: "none",
    },
    noRightBorder: {
      borderRight: "none",
    },
    noBottomBorder: {
      borderBottom: "none",
    },
  }
}

export default FuelAnnexViewStyles;
